import { useState } from 'react';
import SearchTab from './SearchTab';

// טאב חדש = קובץ XxxTab.jsx + רשומה כאן + case ב-renderTab + פונקציות ב-API (service/ProductsService.js)
const TABS = [
  { key: 'search', label: 'השוואת מחירים' },
];

const s = {
  page:     { maxWidth: 1040, margin: '0 auto', padding: '24px 16px 48px' },
  header:   { marginBottom: 20 },
  title:    { margin: 0, fontSize: 28, fontWeight: 700 },
  subtitle: { margin: '4px 0 0', color: '#59636e' },
  nav:      { display: 'flex', gap: 8, margin: '16px 0 0', borderBottom: '1px solid #e5e7eb' },
  navItem:  { padding: '8px 14px', background: 'none', border: 'none', borderBottom: '2px solid transparent', color: '#59636e' },
  navActive:{ color: '#1f2328', fontWeight: 600, borderBottomColor: '#1f2328' },
};

const MainPage = () => {
  const [activeTab, setActiveTab] = useState('search');

  const renderTab = () => {
    switch (activeTab) {
      case 'search':
      default:
        return <SearchTab />;
    }
  };

  return (
    <div style={s.page}>
      <header style={s.header}>
        <h1 style={s.title}>זול בכפר</h1>
        <p style={s.subtitle}>השוואת מחירים</p>
        {TABS.length > 1 && (
          <nav style={s.nav}>
            {TABS.map((tab) => (
              <button
                key={tab.key}
                style={{ ...s.navItem, ...(activeTab === tab.key ? s.navActive : null) }}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        )}
      </header>

      {renderTab()}
    </div>
  );
};

export default MainPage;
